import consumer from './consumer';
import { showAlerts, suggestCandidates, suggestCandidatesError, syncFormWorker } from './job/suggest_candidates';

if (document.querySelector('.page-candidate_suggestions')) {
  window.jobChannelConnected = false;

  const currentCompanyId = document.querySelector('meta[name="current-company-id"]').content;
  const { currentFeature, secureChannelName } = document.querySelector('.main-container[data-current-feature]').dataset;

  consumer.subscriptions.create(
    {
      channel: 'JobChannel',
      company_id: currentCompanyId,
      feature: `${currentFeature}-${secureChannelName}`,
    },
    {
      connected() {
        window.jobChannelConnected = true;
        syncFormWorker();
      },
      disconnected() {
        window.jobChannelConnected = false;
        showAlerts('job-connection-error', true);
      },
      received(data) {
        if (data.status === 'success') {
          if (data.action === 'suggest_candidates') {
            suggestCandidates(data);
          }
        } else if (data.status === 'error') {
          suggestCandidatesError();
        }
      },
    }
  );
}
